import { Flex } from "antd";

import styled from "styled-components";

export const StyledContainer = styled.div`
  height: 100%;
  position: relative;
`;

export const Mask = styled.div<{ $hideImage?: boolean }>`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;

  &::before,
  &::after {
    content: "";
    background: ${({ theme, $hideImage }) =>
      $hideImage ? `#F5F5F5` : `url('${theme.client.assets.background}')`};
    background-size: cover;
    background-position: center;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  /* &::after {
    filter: "";
  } */
`;

export const ContentWrapper = styled(Flex)`
  height: 100%;
  padding: 20px;
`;
